function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIconDM(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "icon/filled/editor/edit",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "8nvkyy8c0a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/filled/editor/edit (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h22v22H0z"
  }))), /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/filled/editor/edit (clip mask)",
    style: {
      fill: "none"
    },
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/filled/editor/edit",
    style: {
      clipPath: "url(#8nvkyy8c0a)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon/filled/editor/edit (clip group)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "icon/filled/editor/edit (style)",
    style: {
      fill: "none"
    },
    d: "M0 0h22v22H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.016 17.187H.172A.172.172 0 0 1 0 17.016v-.773a.688.688 0 0 1 .687-.688H16.5a.688.688 0 0 1 .687.688v.773a.172.172 0 0 1-.171.171zM3.13 13.75a.724.724 0 0 1-.511-.213.735.735 0 0 1-.18-.3.71.71 0 0 1-.021-.345l.634-3.614a.216.216 0 0 1 .06-.114L12.218.063A.209.209 0 0 1 12.371 0a.211.211 0 0 1 .153.063l3.571 3.572a.216.216 0 0 1 .063.152.213.213 0 0 1-.017.082.209.209 0 0 1-.046.069l-9.108 9.108a.209.209 0 0 1-.114.059l-3.613.635a1 1 0 0 1-.13.01z",
    transform: "translate(2.406 2.406)",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconDM);
export default __webpack_public_path__ + "static/media/editIcon_d_m.b902f08c3b69a9cc0a9fb96b9972ab94.svg";
export { ForwardRef as ReactComponent };